import { axios } from '@/services/axios';

export const createRegion = (regionData) => {
    return axios.post('/region/', regionData);
};
